/**
 * 微信jsSKD调用
 */
import Vue from "vue";
import {getWeixinParams, getIsFollowThePublic} from "@/api/user";
import {weixinAppId, BASEPATH, weixinShareParams} from "@/config";
import wx from 'weixin-js-sdk'
import wechatAuth from "../plugins/wechatAuth";
import store from '../store'
import * as ActionTypes from '../store/action-types'
import loading from "../components/loading/loading";
import { Toast } from "vant";
const qs = require('qs')

//==================微信网页授权==================
//调起微信授权
export const startWxAuth = () => {
  // 设置appid
  Vue.use(wechatAuth, {
    appid: weixinAppId
  })
  // 微信未授权登录跳转到授权登录页面
  const url = window.location.href
  // 解决重复登录url添加重复的code与state问题
  const parseUrl = qs.parse(url.split('?')[1])
  let loginUrl
  if (parseUrl.code && parseUrl.state) {
    delete parseUrl.code
    delete parseUrl.state
    loginUrl = `${url.split('?')[0]}?${qs.stringify(parseUrl)}`
  } else {
    loginUrl = url
  }

  // 设置微信授权回调地址
  wechatAuth.redirect_uri = loginUrl
  // 无论拒绝还是授权都设置成1
  store.dispatch(ActionTypes.SET_LOGIN_STATUS, 1)
  // 跳转到微信授权页面
  window.location.href = wechatAuth.authUrl

  //这是重点---隐藏的iframe加载微信支付
  // const iframe = document.createElement('iframe')
  // iframe.style.display = 'none'
  // iframe.setAttribute('src', wechatAuth.authUrl)
  // iframe.setAttribute('sandbox', 'allow-forms allow-modals allow-top-navigation allow-scripts')
  // document.body.appendChild(iframe)
}

//==================微信网页开发==================
//隐藏掉不需要展示的操作item
function hiddenShareItems() {
  wx.hideMenuItems({
    menuList: [
      'menuItem:share:appMessage',
      'menuItem:share:timeline',
      'menuItem:favorite',
      'menuItem:share:qq',
      'menuItem:share:weiboApp',
      'menuItem:share:facebook',
      'menuItem:share:QZone',
      'menuItem:copyUrl',
      'menuItem:openWithQQBrowser',
      'menuItem:openWithSafari',
      'menuItem:share:email']
  });
}

//配置网页中需要使用的api
export function wxConfigWXApi(path, readyFunc = () =>{}) {
  //获得进入页面的url
  let url = encodeURIComponent(path.split("#")[0])

  getWeixinParams({url: url}).then(res => {
    if (!res.data){
      readyFunc(res)
      return;
    }

    wx.config({
      debug: false,
      appId: weixinAppId, // 公众号的唯一标识
      timestamp: res.data.timestamp, // 生成签名的时间戳
      nonceStr: res.data.nonceStr, // 生成签名的随机串
      signature: res.data.signature, // 签名
      jsApiList: [
        "hideMenuItems",
        'showMenuItems',
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "onMenuShareAppMessage",
        "chooseWXPay",//微信支付
        "scanQRCode",//二维码扫描
      ]
    })

    wx.ready(function () {
      //===============分享相关======================
      //1.设置隐藏项
      hiddenShareItems()

      // wx.updateAppMessageShareData({});
      // wx.updateTimelineShareData({});

      //通知外界wx网页配置已经备好
      if (readyFunc){
        readyFunc(res)
      }
    });


    wx.error(function (res) {
      if (res.errMsg != "config.ok") {
        // this.$toast({
        //   message: res.errMsg,
        //   duration: 1000
        // })
      }
    });
  });
}

/**
 * 判断用户是否关注公众号,没有则引导用户关注
 */
export function isAttendThePublic() {
  // return Promise.resolve(true)
  return getIsFollowThePublic().then(res => {
    if (res.code == 0){
      // if (!res.data){
      //   Vue.prototype.$dialog.alert({
      //     message: '需要关注公众号才能继续使用哦~',
      //   }).then(() => {
      //     Vue.prototype.$dialog.close()
      //     setTimeout(() => {
      //       window.location.replace('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzNzIxOTg0MQ==&scene=110#wechat_redirect')
      //     }, 200)
      //   })
      // }else {
      //   Vue.prototype.$dialog.close()
      // }
      return res.data;
    }else {
      Vue.prototype.$toast(res.msg)
      return Promise.reject(res.msg)
    }
  })
}

//==================微信浏览器支付==================
export function wxpay(params,callback){
  if (typeof WeixinJSBridge == "undefined"){
    if( document.addEventListener ){
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady(params,callback), false);
    }else if (document.attachEvent){
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady(params,callback));
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady(params,callback));
    }
  }else{
    onBridgeReady(params,callback);
  }
}

function onBridgeReady(params,callback){
  WeixinJSBridge.invoke(
    'getBrandWCPayRequest',
    {
      "appId":params.appId,
      "timeStamp":params.timeStamp,
      "nonceStr":params.nonceStr,
      "package":params.packages,
      "signType":params.signType,
      "paySign":params.paySign,
    },
    function(res){
      callback && callback(res)
    }
  );
}



//////////////////
// WEBPACK FOOTER
// ./app/lib/wxShare.js
// module id = null
// module chunks = 